export default {
  attribute: {
    position: "POSITION",
    normal: "NORMAL",
    texCoord: "TEXCOORD",
  },
  uniform: {
    _time: "TIME",
    _viewportSize: "VIEWPORT_SIZE",
    _matL: "LOCAL",
    _matM: "MODEL",
    _matV: "VIEW",
    _matP: "PROJECTION",
    _matVM: "MODELVIEW",
    _matPVM: "MODELVIEWPROJECTION",
    _matIM: "MODELINVERSE",
    _matIV: "VIEWINVERSE",
    _matIP: "PROJECTIONINVERSE",
    _matIVM: "MODELVIEWINVERSE",
    _matIPVM: "MODELVIEWPROJECTIONINVERSE",
    _matITM: "MODELINVERSETRANSPOSE",
    _matITVM: "MODELVIEWINVERSETRANSPOSE",
  },
};



// WEBPACK FOOTER //
// ./src/Sort/NameSemanticsPair.ts